
import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function ExpensePrint(body,name) {
    let bList = []
    let monthTotal = ['',0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    body.forEach(element => {
        const b = [
            `[${element.data.name.trim()}]`,
            printFormatNumber(element.data.total),
            printFormatNumber(element.data.jan) ,
            printFormatNumber(element.data.feb),
            printFormatNumber(element.data.mar) ,
            printFormatNumber(element.data.apr) ,
            printFormatNumber(element.data.may) ,
            printFormatNumber(element.data.june) ,
            printFormatNumber(element.data.july),
            printFormatNumber(element.data.aug) ,
            printFormatNumber(element.data.sept) ,
            printFormatNumber(element.data.oct) ,
            printFormatNumber(element.data.nov) ,
            printFormatNumber(element.data.dec) ]
        monthTotal[1] += sF(element.data.jan);
        monthTotal[2] += sF(element.data.feb);
        monthTotal[3] += sF(element.data.mar);
        monthTotal[4] += sF(element.data.apr);
        monthTotal[5] += sF(element.data.may);
        monthTotal[6] += sF(element.data.june);
        monthTotal[7] += sF(element.data.july);
        monthTotal[8] += sF(element.data.aug);
        monthTotal[9] += sF(element.data.sept);
        monthTotal[10] +=sF(element.data.oct);
        monthTotal[11] +=sF(element.data.nov);
        monthTotal[12] +=sF(element.data.dec);
        bList = [...bList, b]
        if (element.children) {
            element.children.forEach(child => {
                const c = [
                    child.data.name,
                    printFormatNumber(child.data.total),
                    printFormatNumber(child.data.jan),
                    printFormatNumber(child.data.feb),
                    printFormatNumber(child.data.mar),
                    printFormatNumber(child.data.apr),
                    printFormatNumber(child.data.may),
                    printFormatNumber(child.data.june),
                    printFormatNumber(child.data.july),
                    printFormatNumber(child.data.aug),
                    printFormatNumber(child.data.sept),
                    printFormatNumber(child.data.oct),
                    printFormatNumber(child.data.nov),
                    printFormatNumber(child.data.dec)
                ]
                bList = [...bList, c]

            })
        }
    })
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
    });
    const heading = [ 'Name', 'Total', 'Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Expenses Report", 500, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 500, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            foot: [monthTotal.map(item =>{
                return item.toLocaleString()
            })],
            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "right"},
                2: {halign: "right"},
                3: {halign: "right"},
                4: {halign: "right"},
                5: {halign: "right"},
                6: {halign: "right"},
                7: {halign: "right"},
                8: {halign: "right"},
                9: {halign: "right"},
                10: {halign: "right"},
                11: {halign: "right"},
                12: {halign: "right"},
                13: {halign: "right"},
                14: {halign: "right"},
            },
        }
    )
    doc.save('Expenses.pdf');
}





